/**
 * Photos d'une carte produit, selon l'appareil :
 * - souris : la 2e image reçoit sa source au premier survol réel. `(hover: hover)` seul ne suffit
 *   pas à empêcher le chargement, un `<img loading="lazy">` peut déjà atteindre le seuil de
 *   préchargement natif avant que la carte soit visible : la source reste en `data-src` jusqu'au
 *   premier `pointerenter`, pour qu'elle ne parte jamais avant le besoin ;
 * - écran tactile : les photos de la galerie reçoivent leur source (même raison : `display: none`
 *   n'empêche pas WebKit de télécharger une image lazy, elles restent donc en `data-src` ailleurs),
 *   se font glisser au doigt (défilement natif, CSS de la carte) et les points suivent la photo
 *   affichée.
 */
class ProductCardMedia extends HTMLElement {
  #listeners = null;
  #slides = null;
  #dots = [];

  connectedCallback() {
    this.#listeners = new AbortController();
    const { signal } = this.#listeners;

    if (window.matchMedia('(hover: hover)').matches) {
      this.addEventListener('pointerenter', () => this.#revealHoverImage(), { once: true, signal });
      return;
    }

    this.#slides = this.querySelector('[data-swipe]');
    this.#dots = Array.from(this.querySelectorAll('.product-card-brand__dot'));
    if (this.#slides && this.#dots.length) {
      this.#slides.querySelectorAll('.product-card-brand__image--slide').forEach((image) => ProductCardMedia.#load(image));
      this.#slides.addEventListener('scroll', this.#syncDots, { passive: true, signal });
    }
  }

  disconnectedCallback() {
    this.#listeners?.abort();
  }

  #revealHoverImage() {
    const image = this.querySelector('.product-card-brand__image--secondary');
    if (image) ProductCardMedia.#load(image);
  }

  static #load(image) {
    if (image.src) return;
    if (image.dataset.srcset) image.srcset = image.dataset.srcset;
    if (image.dataset.sizes) image.sizes = image.dataset.sizes;
    if (image.dataset.src) image.src = image.dataset.src;
  }

  #syncDots = () => {
    const width = this.#slides.clientWidth;
    if (!width) return;
    const last = this.#dots.length - 1;
    const active = Math.min(Math.max(Math.round(this.#slides.scrollLeft / width), 0), last);
    this.#dots.forEach((dot, index) => dot.toggleAttribute('data-active', index === active));
  };
}

if (!customElements.get('product-card-media')) {
  customElements.define('product-card-media', ProductCardMedia);
}
